export interface CampaignApplicationColumn {
    key: string;
    label: string;
    sortKey: string;
}

// All available columns for the Campaign Application results table.
// Single source of truth shared by CampaignApplicationAccordionItem (picker)
// and CampaignApplicationSearchResults (table + selection).
export const ALL_AVAILABLE_COLUMNS: CampaignApplicationColumn[] = [
    { key: 'pc_name', label: 'Contact Name', sortKey: 'pc_last_name' },
    { key: 'patient_name', label: 'Client Name', sortKey: 'patient_name' },
    { key: 'requirements', label: 'Requirements', sortKey: 'requirements' },
    { key: 'campaign_csc', label: 'CSC', sortKey: 'campaign_csc' },
    { key: 'campaign_medical_reason', label: 'Medical Reason', sortKey: 'campaign_medical_reason' },
    { key: 'campaign_status', label: 'Campaign Status', sortKey: 'campaign_status' },
    { key: 'pc_email', label: 'Contact Email', sortKey: 'pc_email' },
    { key: 'pc_phone', label: 'Contact Phone', sortKey: 'pc_phone_cell' },
    { key: 'campaign_approved_date', label: 'Approved Date', sortKey: 'campaign_approved_date' },
    { key: 'created_date', label: 'Created Date', sortKey: 'created_date' },
    { key: 'update_date', label: 'Last Updated', sortKey: 'update_date' },
    { key: 'photo_consented', label: 'Photo Consented', sortKey: 'ag_understand_hhl_may_use_photos' },
    { key: 'photo_url', label: 'Photo', sortKey: 'photo_url' },
];

export const DEFAULT_VISIBLE_COLUMNS: string[] = [
    'pc_name',
    'patient_name',
    'requirements',
    'campaign_csc',
    'campaign_medical_reason',
    'campaign_status',
    'created_date',
    'update_date',
];

// Parse a `visible_columns` URL value (comma-joined keys) into a validated key list.
// Returns DEFAULT_VISIBLE_COLUMNS when the value is missing or yields no valid keys.
export const parseVisibleColumns = (raw: string | null): string[] => {
    if (raw) {
        const valid = new Set(ALL_AVAILABLE_COLUMNS.map(c => c.key));
        const parsed = raw.split(',').map(s => s.trim()).filter(k => valid.has(k));
        if (parsed.length) return parsed;
    }
    return DEFAULT_VISIBLE_COLUMNS;
};

// True when `selected` is exactly the default set (order-independent).
export const isDefaultSelection = (selected: string[]): boolean =>
    selected.length === DEFAULT_VISIBLE_COLUMNS.length &&
    selected.every(k => DEFAULT_VISIBLE_COLUMNS.includes(k));
